import { makeAutoObservable } from 'mobx'
import { type EntityId, idKey } from '../types/constants'

export class UserStore {
    fetching = false
    loaded = false
    user: Models.User | null = null
    profileId: EntityId | null = null

    constructor() {
        makeAutoObservable(this)
    }

    setFetching(fetching: boolean) {
        this.fetching = fetching
    }

    setUser(user: Models.User) {
        this.user = user
        this.fetching = false
        this.loaded = true
    }

    setProfileId(profileId: EntityId | null) {
        this.profileId = profileId
    }

    clearUser() {
        this.user = null
        this.profileId = null
        this.fetching = false
        this.loaded = true
    }

    get profiles() {
        return this.user?.keys?.profiles || []
    }

    get activeProfile() {
        // MER-2802: profile_id may arrive as a number or a string. Compare on String(...).
        const wanted = idKey(this.profileId)
        return this.profiles.find((p) => idKey(p.profile_id) === wanted)
    }

    get isKdp() {
        return this.activeProfile?.is_kdp ?? false
    }

    get isEligibleForProductAdRecipes(): boolean {
        return this.user?.id == 224
    }
}

export const userStore = new UserStore()
